import http from './api'

const route = 'app/comercial/cliente3/'

export default {
  showFatPrincipaisClientes3: (primeiroDia, ultimoDia, select, supervisor, area, rede, vendedor, receita, tokencontrato, segmento, categoria, promotor, classificacao) => {
    return http.post(route + 'showFatPrincipaisClientes3', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedor,
      supervisor: supervisor,
      area: area,
      rede: rede,
      receita: receita,
      tokenContrato: tokencontrato,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
    })
  },

  showDetalhePrincipaisClientes3: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, cidade, vendedores, classificacao) => {
    return http.post(route + 'showDetalhePrincipaisClientes3', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      cidade: cidade,
      vendedores: vendedores,
      classificacao: classificacao,
    })
  },

  showClientesDevolucaoImpropriaMotivos: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades) => {
    return http.post(route + 'showClientesDevolucaoImpropriaMotivos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
    })
  },
}
